import { Component, OnInit, Input,OnChanges } from '@angular/core';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-timer-circle-multi',
  templateUrl: './timer-circle-multi.component.html',
  styleUrls: [],
})
export class TimerCircleMultiComponent implements OnInit,OnChanges {
  subscription!: Subscription;

  @Input() duration!: number;
  @Input() timeLeft!: number;
  @Input() percent = 100;
  @Input() second!: number;
  @Input() isMinuts!: boolean;
  currentColor = '#F9C10B';

  constructor() {
    // this.timerAuctionNoEndTime(
    //   this.duration,
    //   this.timeLeft,
    //   this.percent,
    //   this.second
    // );
  }

  ngOnInit() {}
  ngOnChanges(changes: any): void {
    // console.log(changes)
    this.timerAuctionNoEndTime(
      this.duration,
      this.timeLeft,
      this.percent,
      this.second
    );
  }

  timerAuctionNoEndTime(
    duration: any,
    timeLeft: any,
    percent: any,
    second: any
  ) {
    this.percent = percent;

    this.second = second;
    // console.log(this.duration)
    // console.log(this.timeLeft)
    // if (this.duration==90) {
    //   this.timeLeft = this.timeLeft - 90;
    //   this.percent = (this.timeLeft / this.duration) * 100;
    // }
    // if (this.timeLeft < 60 && this.timeLeft > 30) {
    //   this.timeLeft = this.timeLeft - 30;
    //   this.percent = (this.timeLeft / this.duration) * 100;
    // }
    this.timeLeft--;
    this.second--;
    this.percent = (this.timeLeft / this.duration) * 100;
  }

  getPercent() {
    // console.log(this.percent);
    // console.log(this.duration);

    if (this.percent <= 33.33 && this.duration == 90) {
      return (this.currentColor = '#B20908'); // red
    } else if (this.percent <= 66.66 && this.duration == 90) {
      return (this.currentColor = '#F4680C'); // orange
    } else {
      return (this.currentColor = '#F9C10B'); // yellow
    }
  }
  unsubscribeTimerAuctionNoEndTime() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
